import {Item} from '@/store/modules/issue/types'

export const initItem: ItemFormData = {
  itemName: '',
  supplyCost: 0,
  unitCost: 0,
  tax: 0,
  taxFree: false,
  qty: 1,
  purchaseDate: '',
  spec: '',
  remark: '',
  totalAmount: 0,
  taxType: '영세',
}

export interface ItemFormData extends Item {
  totalAmount: number | string
  taxFree: boolean
}
